import { type ButtonProps } from "@tokenterminal/core/ui/button/Button"
import { SelectField } from "@tokenterminal/core/ui/input/SelectField"

import { type Interval } from "@tokenterminal/tt-analytics-api-types/dist/api/zoom"
import { type GranularityType } from "@tokenterminal/ui/Chart/utils/groupDataBasedOnGranularity"

type IntervalSelectFieldProps = {
  selectedKey: Interval
  setInterval: (interval: Interval) => void
  setGranularity?: (granularity: GranularityType) => void
  buttonProps?: Partial<ButtonProps>
}

const IntervalSelectField = ({
  selectedKey,
  setInterval,
  setGranularity,
  buttonProps,
}: IntervalSelectFieldProps) => {
  return (
    <SelectField
      selectedKey={selectedKey}
      onSelectionChange={(value) => {
        setInterval(value as Interval)
        if (!setGranularity) return

        if (value === "24h") {
          setGranularity("day")
        } else if (value === "7d") {
          setGranularity("day")
        } else if (value === "30d") {
          setGranularity("day")
        } else if (value === "90d") {
          setGranularity("week")
        } else if (value === "180d") {
          setGranularity("week")
        } else if (value === "365d") {
          setGranularity("week")
        } else if (value === "max") {
          setGranularity("week")
        }
      }}
      aria-label="Date range"
      buttonProps={buttonProps}
    >
      <SelectField.Option id="24h">Last 24 hours</SelectField.Option>
      <SelectField.Option id="7d">Last 7 days</SelectField.Option>
      <SelectField.Option id="30d">Last 30 days</SelectField.Option>
      <SelectField.Option id="90d">Last 90 days</SelectField.Option>
      <SelectField.Option id="180d">Last 180 days</SelectField.Option>
      <SelectField.Option id="365d">Last 365 days</SelectField.Option>
      <SelectField.Option id="max">All time</SelectField.Option>
      <SelectField.Option id="ytd">Year to date</SelectField.Option>
    </SelectField>
  )
}

export default IntervalSelectField
